import { Composition } from 'remotion';
import {
  AIGeneratedAnimationPattern,
} from '../effects/Effects276-278';
import {
  GenerativeArtGrid,
} from '../effects/Effects296-298';
import {
  PixelateTransition,
  CollageTransition,
} from '../effects/Effects299-301';
import {
  LightLeakTransitionEnhanced,
  PerlinNoiseFlowField,
} from '../effects/Effects302-304';
import { AutoHeightExpand } from '../effects/AutoHeightExpand';
import { DynamicBlurReveal } from '../effects/DynamicBlurReveal';
import { GameTrailerTemplate, GameTrailerDemo } from '../templates/GameTrailerTemplate';
import { GLTransitionsRippleDissolve } from '../effects/GLTransitionsRippleDissolve';
import { ProceduralTextureGenerator } from '../effects/ProceduralTextureGenerator';
import { ScrollDrivenAnimation } from '../effects/ScrollDrivenAnimation';
import { TextMorphing } from '../effects/TextMorphing';

export const Research2026Compositions = () => (
  <>
      {/* 🎨 2026-03-04 新效果（#270-#272）✨ 每日研究任务 */}
      {/* 🎨 2026-03-04 新效果（#273-#274）✨ 每日研究任务 */}
      <Composition
        id="TextMorphing"
        component={TextMorphing}
        durationInFrames={120}
        fps={30}
        width={1920}
        height={1080}
      />
      {/* 🎨 2026-03-04 新效果（#273-#275）✨ 每日研究任务 */}
      {/* 🎨 2026-03-04 新效果（#276-#278）✨ 每日研究任务 - 流体/WebGL/AI */}
      <Composition
        id="AIGeneratedAnimationPattern"
        component={AIGeneratedAnimationPattern}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
      />
      {/* 🎨 2026-03-04 新效果（#279-#281）✨ 每日研究任务 - 生命周期/3D文字/音频波形 */}

      {/* 🎨 新效果 #282-#284：每日研究任务 - 滚动排版/AI图案/3D粒子球（2026-03-04 19:35） */}
      {/* 🎨 2026-03-04 新效果（#285-#287）✨ 每日研究任务 - Motion Blur/Path Animation/Noise Particle */}

      {/* 🎨 2026-03-04 新效果（#288-#290）✨ 每日研究任务 - 第三轮（21:35）*/}
      {/* 🎨 2026-03-05 新效果（#291-#292）✨ 每日研究任务 */}

      {/* 🎨 2026-03-05 新效果（#293-#295）✨ 每日研究任务 - WebGL/流体/AI */}

      {/* 🎨 2026-03-05 新效果（#296-#298）✨ 每日研究任务 - 轨迹/音频/生成艺术 */}
      <Composition
        id="GenerativeArtGrid"
        component={GenerativeArtGrid}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={{
          gridSize: 20,
          color1: '#00ffff',
          color2: '#ff00ff',
        }}
      />

      {/* 🎨 2026-03-05 新效果（#296-#298）✨ 每日研究任务 - CSS/WebGPU/物理模拟 */}
      <Composition
        id="ScrollDrivenAnimation"
        component={ScrollDrivenAnimation}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
      />
      {/* 🎨 2026-03-05 新效果（#299-#301）✨ 每日研究任务 - 视频转场效果 */}
      <Composition
        id="PixelateTransition"
        component={PixelateTransition}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={{
          text: 'PIXEL',
          gridSize: 20,
          color1: '#ff0080',
          color2: '#00ffff',
          backgroundColor: '#0a0010',
        }}
      />
      <Composition
        id="CollageTransition"
        component={CollageTransition}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={{
          text: 'COLLAGE',
          rows: 4,
          cols: 4,
          color1: '#f59e0b',
          color2: '#06b6d4',
          backgroundColor: '#0f0f1e',
        }}
      />

      {/* 🎨 2026-03-05 新效果（#302-#304）✨ 每日研究任务 - WebGL/光泄漏/流场 */}
      <Composition
        id="LightLeakTransitionEnhanced"
        component={LightLeakTransitionEnhanced}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
      />
      <Composition
        id="PerlinNoiseFlowField"
        component={PerlinNoiseFlowField}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
      />

      {/* 🎨 2026-03-05 新效果（#305-#307）✨ 每日研究任务 - 粒子路径/磁场/流场艺术 */}
      {/* 🎨 2026-03-05 新效果（#311-#313）✨ 每日研究任务 - Motion 交互/模糊揭示/高度展开 */}
      <Composition
        id="DynamicBlurReveal"
        component={DynamicBlurReveal}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
      />
      <Composition
        id="AutoHeightExpand"
        component={AutoHeightExpand}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
      />
      <Composition
        id="GLTransitionsRippleDissolve"
        component={GLTransitionsRippleDissolve}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
      />

      {/* 🎨 2026-03-05 新效果（#317-#319）✨ 每日研究任务 - 粒子涟漪/时间扭曲/极光粒子 */}

      {/* 🎨 2026-03-05 新效果（#320-#322）✨ 每日研究任务 - 自然现象/AI动画 */}
      {/* 🎨 2026-03-05 新效果（#323-#325）✨ 自然现象模拟 + 星系动画 */}

      {/* 🎨 2026-03-05 新效果（#326-#328）✨ 每日研究任务 - 音频可视化/流场/AI动画 */}

      {/* 🎨 2026-03-05 新效果（#323-#325）✨ 每日研究任务 - 第二轮 */}
      {/* 🎨 2026-03-05 Just-in-Time Compilation 测试页面 */}
      {/* 🎨 2026-03-05 新增效果：粒子星云系统 */}
      {/* QuantumEntanglement: 组件文件不存在，暂时禁用 */}
      {/* <Composition id="QuantumEntanglement" component={QuantumEntanglement} durationInFrames={150} fps={30} width={1920} height={1080} /> */}

      {/* 🎨 2026-03-06 新效果（#329-#331）✨ 每日研究任务 - WebGL/液态/墨水效果 */}
      {/* 🎨 2026-03-06 新效果（#332-#334）✨ 每日研究任务 - SVG/纹理/3D音频 */}
      <Composition
        id="ProceduralTextureGenerator"
        component={ProceduralTextureGenerator}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
      />
      {/* 🎨 2026-03-06 新效果（#336-#337）✨ 每日研究任务 - 生成艺术/AI */}
      {/* 🎨 2026-03-06 新效果（#335-#337）✨ 每日研究任务 - AI/物理/生成艺术 */}

  </>
);
